const s = {
  name: "_2ArrowsDown",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39.9 39.9" style="enable-background:new 0 0 39.9 39.9;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<path class="st0" d="M20,18.5L1.4,0L0,1.4l20,20l20-20L38.5,0L20,18.5z"/>
<path class="st0" d="M20,37.1L1.4,18.5L0,20l20,20l20-20l-1.4-1.4L20,37.1z"/>
</svg>
  `
};
export {
  s as _2ArrowsDown
};
